import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { ngHelper, getLineBreakersQuantity, getLengthWithoutLineBreakers, CustomComponent } from '@cakeiteasy/web-utils';
import { Subject } from 'rxjs';
import {debounceTime, filter} from "rxjs/operators";

@Component({
  standalone: false,
  selector: 'ui-cake-build-text',
  templateUrl: './ui-cake-build-text.component.html'
})
export class UiCakeBuildTextComponent extends CustomComponent implements OnChanges {
  @Input() public text: string = '';
  @Input() public maxLength: number = 0;
  @Input() public price: number;
  @Input() public currency = 'kr';
  @Output() public onChange: EventEmitter<any> = new EventEmitter();

  public textLength: number = 0;
  public textChanged$ = new Subject<string>();

  constructor() {
    super();
    this._subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    ngHelper.ifChanged(changes, 'maxLength', (maxLength: any) => {
      if (this.text && getLengthWithoutLineBreakers(this.text) > maxLength) {
        const endPosition = maxLength + getLineBreakersQuantity(this.text);
        const text = this.text.substr(0, endPosition);
        setTimeout(() => {
          this.onChange.emit(text);
        });
      }
    });
  }

  private _subscribe() {
    this.addSubscriber(this.textChanged$.pipe(
      filter((text) => text !== undefined),
      debounceTime(50),
      ).subscribe((text: string) => {
        this.textLength = getLengthWithoutLineBreakers(text);
        const endPosition = this.maxLength + getLineBreakersQuantity(text);
        this.text = text.substr(0, endPosition);
        this.onChange.emit(this.text);
      }));
  }
}

